import Vue from 'vue';
import gridProps from '@/gridProps';
import {
  formatNumber,
  alignForNumber,
  LinkCellRenderer,
  autoResize,
  ProgressBarByFieldsRenderer
} from '@/helpers/renderHelpers';
import {
  addColIdToColumns,
  handlerResponse,
} from '@/helpers/commonHelpers';
import { cellRenderForSalesOrdersGrid } from '@/helpers/salesOrdersHelpers';

export default {
  namespaced: true,
  state: {
    salesOrders: [],
    columns: [],
    salesOrdersCount: null,
    gridOptions: {
      animateRows: true,
      rowSelection: 'multiple',
      components: {
        'BuyerLink': LinkCellRenderer('partner', '/partners/'),
        'SalesOrderLink': LinkCellRenderer('id', '/sales-orders/'),
        'SalesContractLink': LinkCellRenderer('sales_contract', '/sales-contracts/'),
        'ReadinessProgressBar': ProgressBarByFieldsRenderer('current_m3', 'm3'),
        'cellRenderForSalesOrdersGrid': cellRenderForSalesOrdersGrid,
        'ReadinessProgressBarM3': ProgressBarByFieldsRenderer('reserved_product_m3', 'unshipped_m3'),
      },
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
        valueFormatter(params) {
          return formatNumber(params.value, null);
        },
        cellStyle(params) {
          return alignForNumber(params.value);
        },
        tooltipValueGetter(params) {
          if (params.data.free_movement_data_exist && params.data.zero_price_item_exists) {
            return 'Order has items without price and unbounded packages';
          } else if (params.data.zero_price_item_exists) {
            return 'Order has items without price';
          } else if (params.data.free_movement_data_exist) {
            return 'Order has unbounded packages';
          }
        }
      },
      onRowDataChanged() {
        if (this.rowData && this.rowData.length) {
          autoResize(this);
        } else {
          this.api && this.api.hideOverlay();
          this.api && this.api.showNoRowsOverlay();
        }
      },
      onGridReady() {
        this.api.showLoadingOverlay();
      }
    },
    plainSalesOrders: [],
    gridName: ''
  },
  getters: {
    salesOrders(state) {
      return state.salesOrders;
    },
    columns(state) {
      return state.columns;
    },
    gridOptions(state) {
      return {...state.gridOptions, ...gridProps};
    },
    salesOrdersCount(state) {
      return state.salesOrdersCount;
    },
    plainSalesOrder: (state) => state.plainSalesOrder
  },
  mutations: {
    setData(state, payLoad) {
      state.salesOrders = payLoad
      if (payLoad.data) {
        state.salesOrders = payLoad.data.results;
        state.salesOrdersCount = payLoad.data.count;
      } else {
        state.salesOrdersCount = payLoad;
      }
      state.columns = addColIdToColumns(payLoad.used_columns);
      state.gridName = payLoad.grid_name;
    },
    setPlainData(state, payload) {
      state.plainSalesOrders = payload
    }
  },
  actions: {

    loadPlainSalesOrders(store, payload) {
      if (store.getters.gridOptions.api) {
        store.getters.gridOptions.api.showLoadingOverlay();
      }
      Vue.http.get('woodware/list/salesorders/', {params: payload})
        .then(handlerResponse)
        .then(data => {
          store.commit('setPlainData', data);
        });
    },
    loadSalesOrders(store, payload) {
      if (store.getters.gridOptions.api) {
        store.getters.gridOptions.api.showLoadingOverlay();
      }
      // TODO: this should be discussed again
      Vue.http.get('sales/search_for_sales_orders/', {params: payload})
        .then(handlerResponse)
        .then(data => {
          store.commit('setData', data);
        });
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/sales/orders/salesOrders.js